<template>
  <div class="preload-downloading" v-show="visible">
    <el-dialog
      title=""
      :visible.sync="visible"
      top="30vh"
      width="940px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="preload-dialogue"
    >
      <div class="preload-downloading__body">
        <div class="preload-downloading__progress">
          <div class="preload-downloading__progress-bar" :style="{ width: progress + '%' }"></div>
        </div>
      </div>
      <div class="intro-wrap">
        <p>{{ dialogue_preload_intro_first }}</p>
        <!-- <p>{{ dialogue_preload_intro_second }}</p>
        <b>{{ dialogue_preload_intro_third }}</b> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '@/locales'

export default {
  name: 'DownLoading',
  props: {
    title: {
      type: String,
      default: '',
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: false,
    },
    // 取消下载事件
    cancelHandler: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      progress: 0,
      dialogue_preload_intro_first: i18n.t('dialogue_preload_intro_first'),
      dialogue_preload_intro_second: i18n.t('dialogue_preload_intro_second'),
      dialogue_preload_intro_third: i18n.t('dialogue_preload_intro_third'),
    }
  },
  computed: {
    downTitle() {
      return i18n.t('dialogue_preload_title')
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
::v-deep .preload-dialogue {
  .el-dialog__header {
    border-bottom: 1px solid #e9e9e9;
    padding: 20px 20px 10px;
    .el-dialog__title {
      color: #2c2f46;
      font-size: 18px;
    }
  }
  .el-dialog__body {
    padding: 80px 160px;
    .intro-wrap {
      color: #696974;
      font-size: 14px;
      p:first-of-type {
        margin-top: 17px;
      }
      p:last-of-type {
        margin-top: 5px;
        margin-bottom: 12px;
      }
      b {
        font-size: 16px;
      }
    }
  }
}
.preload-downloading {
  &__close {
    position: absolute;
    z-index: 11;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;

    .icon-close {
      display: block;
      width: 12px;
      height: 12px;
      background-image: url(~@/assets/images/icon-close.png);
    }
  }

  &__container {
    position: absolute;
    z-index: 10001;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    min-height: 85px;
    background-color: #fff;
    -webkit-box-shadow: 0 2px 3px 3px rgba(0, 0, 0, 0.05);
    box-shadow: 0 2px 3px 3px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
  }

  &__mask {
    position: absolute;
    z-index: 10000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.5;
  }

  &__title {
    padding: 24px 10px 0;
    text-align: center;
    font-size: 14px;
  }

  &__body {
    // padding: 10px;
  }

  &__progress {
    height: 8px;
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  &__progress-bar {
    width: 0;
    height: 100%;
    border-radius: 4px;
    background-color: #faae56;
  }
}
</style>
